<template>
  <figure>
    <transition name="component-fade" mode="out-in">
      <img :src="img" :key="img" :alt="imgDescription" />
    </transition>
  </figure>
</template>
<script>
import contentBuilder from "@/mixins/contentBuilder";
import labels from "@/data/labels.json";
export default {
  data() {
    return {
      labels,
    };
  },
  mixins: [contentBuilder],
  computed: {
    level() {
      if (Object.keys(this.$route.query).length > 0) {
        let lastLevel = Object.keys(this.$route.query)
          .at(-1)
          .replace("level", "");
        return lastLevel ? Number(lastLevel) : 0;
      } else {
        return 0;
      }
    },
    img() {
      return this.content.img ? this.content.img : "./images/00-homepage.jpg";
    },
    imgDescription() {
      return this.content.imgDescription
        ? this.content.imgDescription
        : labels.SEN_GUIDA_DEFAULT_IMAGE_DESCRIPTION;
    },
  },
};
</script>
<style>
.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
